import type { IconSvgProps } from "@modules/ui/components/huButtonIcon"

/**
 * Icon for BoxStaffCoOwner, it's a key icon
 * @param props
 * @returns
 */
export const BoxStaffCoOwnerIcon: React.FC<IconSvgProps> = (props) => (
  <svg width="50" height="51" viewBox="0 0 50 51" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask
      id="mask0_12013_138061"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="9"
      y="8"
      width="21"
      height="32"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.6991 23.08C24.7545 23.4278 27.8252 21.8272 29.2084 18.8907C30.945 15.204 29.3641 10.8075 25.6774 9.0709C21.9906 7.3343 17.5942 8.91521 15.8576 12.602C14.5431 15.3924 15.1293 18.5895 17.0906 20.732L9.80877 36.1911L11.6825 39.5538L14.8729 38.5765L15.1497 36.1188L16.8788 34.3181L16.612 32.2874L18.3788 31.1335L18.5394 28.1956L20.8906 25.8012L20.6678 24.404L21.6991 23.08ZM25.4145 13.8382C24.9923 14.7344 23.9236 15.1187 23.0274 14.6966C22.1312 14.2744 21.7469 13.2057 22.169 12.3095C22.5912 11.4133 23.6599 11.029 24.5561 11.4511C25.4523 11.8733 25.8366 12.942 25.4145 13.8382Z"
        fill="#6450F7"
      />
    </mask>
    <g mask="url(#mask0_12013_138061)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.6991 23.08C24.7545 23.4278 27.8252 21.8272 29.2084 18.8907C30.945 15.204 29.3641 10.8075 25.6774 9.0709C21.9906 7.3343 17.5942 8.91521 15.8576 12.602C14.5431 15.3924 15.1293 18.5895 17.0906 20.732L9.80877 36.1911L11.6825 39.5538L14.8729 38.5765L15.1497 36.1188L16.8788 34.3181L16.612 32.2874L18.3788 31.1335L18.5394 28.1956L20.8906 25.8012L20.6678 24.404L21.6991 23.08ZM25.4145 13.8382C24.9923 14.7344 23.9236 15.1187 23.0274 14.6966C22.1312 14.2744 21.7469 13.2057 22.169 12.3095C22.5912 11.4133 23.6599 11.029 24.5561 11.4511C25.4523 11.8733 25.8366 12.942 25.4145 13.8382Z"
        fill="#3B3184"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.9139 22.8115C23.9694 23.1592 27.0401 21.5587 28.4233 18.6222C30.1599 14.9354 28.579 10.5389 24.8922 8.80235C21.2055 7.06575 16.809 8.64665 15.0724 12.3334C13.758 15.1239 14.3441 18.3209 16.3054 20.4635L9.02361 35.9226L10.8973 39.2852L14.0877 38.308L14.3645 35.8503L16.0936 34.0495L15.8268 32.0189L17.5937 30.865L17.7542 27.9271L20.1054 25.5326L19.8826 24.1355L20.9139 22.8115ZM24.6293 13.5697C24.2072 14.4659 23.1384 14.8502 22.2422 14.428C21.346 14.0059 20.9617 12.9371 21.3839 12.0409C21.806 11.1447 22.8748 10.7604 23.771 11.1826C24.6672 11.6047 25.0515 12.6735 24.6293 13.5697Z"
        fill="#6450F7"
      />
      <rect
        x="17.6426"
        y="22.0654"
        width="0.709625"
        height="15.2184"
        transform="rotate(26.0553 17.6426 22.0654)"
        fill="#3B3184"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.4865 11.3999C24.2474 11.509 24.0513 11.6599 23.904 11.8545C22.6312 13.5367 25.4923 17.8459 30.2944 21.4795C35.0966 25.113 40.0213 26.6949 41.2941 25.0128C42.5669 23.3306 39.7058 19.0214 34.9037 15.3878C32.7749 13.777 30.6219 12.5694 28.7737 11.8706C29.0351 12.3519 29.2603 12.8788 29.3943 13.2111C30.9072 13.8943 32.6029 14.9009 34.3003 16.1853C36.6361 17.9526 38.4647 19.8598 39.5439 21.4852C40.0862 22.302 40.4075 23.0002 40.5345 23.5395C40.6634 24.0867 40.5635 24.321 40.4967 24.4094C40.4298 24.4977 40.2314 24.6576 39.6698 24.6823C39.1163 24.7066 38.357 24.5873 37.4236 24.2874C35.566 23.6908 33.2336 22.4494 30.8978 20.682C28.562 18.9147 26.7334 17.0075 25.6542 15.3821C25.1119 14.5653 24.7906 13.8671 24.6636 13.3278C24.5347 12.7806 24.6346 12.5463 24.7015 12.4579C24.7609 12.3794 24.924 12.2445 25.3535 12.198C25.3493 12.1923 25.3451 12.1868 25.3408 12.1814C24.9443 11.681 24.6231 11.473 24.4865 11.3999Z"
      fill="url(#paint0_linear_12013_138061)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.6237 11.4919C23.7861 13.3265 26.5984 17.3974 31.1694 20.856C35.9716 24.4896 40.8963 26.0715 42.1691 24.3893C43.4419 22.7071 40.5808 18.3979 35.7787 14.7643C32.9565 12.6289 30.0919 11.2021 27.9512 10.73C28.3162 11.1501 28.6834 11.7016 28.8972 12.0388C30.7122 12.6632 32.9422 13.8721 35.1753 15.5618C37.5111 17.3292 39.3397 19.2363 40.4189 20.8617C40.9612 21.6785 41.2825 22.3768 41.4095 22.916C41.5384 23.4632 41.4385 23.6976 41.3717 23.7859C41.3048 23.8743 41.1064 24.0341 40.5448 24.0588C39.9913 24.0832 39.232 23.9638 38.2986 23.664C36.441 23.0673 34.1086 21.826 31.7728 20.0586C29.437 18.2912 27.6084 16.3841 26.5292 14.7586C25.9869 13.9419 25.6656 13.2436 25.5386 12.7044C25.5197 12.624 25.5057 12.5504 25.4958 12.4831C25.4763 12.4388 25.4401 12.3653 25.3741 12.2431C25.0689 11.679 24.7633 11.5308 24.6237 11.4919Z"
      fill="url(#paint1_linear_12013_138061)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_12013_138061"
        x1="27.2445"
        y1="18.5436"
        x2="41.9548"
        y2="18.0604"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#D1D1D1" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_12013_138061"
        x1="27.9354"
        y1="17.5235"
        x2="42.6467"
        y2="17.0558"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#D1D1D1" />
      </linearGradient>
    </defs>
  </svg>
)
